import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LumiloginInterceptorService } from './service/lumilogin.interceptor.service';
import { LumiloginService } from './service/lumilogin.service';
import { LUMILOGIN_URL, LUMILOGIN_CLIENTID, LUMILOGIN_REALM, LUMILOGIN_SECRET, APPLICATION_NAME, THEME_CONFIG, URL_API_LUMILOGIN, SHOW_SEARCH_BAR, SHOW_LANG_SELECTOR, DOC_URL, SHOW_HELP, SHOW_CGU } from './lumilogin.token';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SubheaderModule } from './subheader/subheader.module';
import { HeadernavModule } from './headernav/headernav.module';
import { ApplicationService } from './api/applications/application.service';
import { CustomerTreeService } from './api/customer-tree/customer-tree.service';
import { RoleService } from './api/role/role.service';
import { UserService } from './api/user/user.service';
import { UserAccessService } from './api/user-access/user-access.service';
import { UserApplicationService } from './api/user-application/user-application.service';
import { WebServicesService } from './api/web-services/web-services.service';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';

@NgModule({
	declarations: [HeaderComponent, FooterComponent],
	imports: [
		CommonModule,
		HttpClientModule,
		NgbModule,
		TranslateModule,
		FormsModule,
		HeadernavModule,
		ToastrModule.forRoot(),
		ConfirmDialogModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LumiloginInterceptorService,
			multi: true
		},
		DatePipe,
		LumiloginService,
		ApplicationService,
		CustomerTreeService,
		RoleService,
		UserService,
		UserAccessService,
		UserApplicationService,
		WebServicesService
	],
	exports: [
		HeaderComponent,
		FooterComponent,
		SubheaderModule
	]
})
export class LumiloginModule {
	static forRoot(
		lumilogin_url: string,
		lumilogin_realm: string,
		lumilogin_clientid: string,
		lumilogin_secret: string,
		application_name: string,
		theme_config: any,
		urlApiLumilogin: string,
		show_Search_Bar: boolean,
		show_Lang_Selector: boolean,
		doc_url: string,
		show_help: boolean,
		show_cgu: boolean
	) {
		return {
			ngModule: LumiloginModule,
			providers: [
				{
					provide: LUMILOGIN_URL,
					useValue: lumilogin_url
				},
				{
					provide: LUMILOGIN_REALM,
					useValue: lumilogin_realm
				},
				{
					provide: LUMILOGIN_CLIENTID,
					useValue: lumilogin_clientid
				},
				{
					provide: LUMILOGIN_SECRET,
					useValue: lumilogin_secret
				},
				{
					provide: APPLICATION_NAME,
					useValue: application_name
				},
				{
					provide: THEME_CONFIG,
					useValue: theme_config
				},
				{
					provide: URL_API_LUMILOGIN,
					useValue: urlApiLumilogin
				},
				{
					provide: SHOW_SEARCH_BAR,
					useValue: show_Search_Bar
				},
				{
					provide: SHOW_LANG_SELECTOR,
					useValue: show_Lang_Selector
				},
				{
					provide: DOC_URL,
					useValue: doc_url
				},
				{
					provide: SHOW_HELP,
					useValue: show_help
				},
				{
					provide: SHOW_CGU,
					useValue: show_cgu
				}
			]
		}
	}
}